import { captureFromCurrentUrl, getPersistedParams } from './store'

/**
 * Returns persisted marketing params as a flat key/value record suitable for
 * spreading into Pages Router `router.push({ query })` calls.
 */
export function getMarketingParamsQueryRecord(): Record<string, string> {
  captureFromCurrentUrl()

  const persisted = getPersistedParams()

  return Object.fromEntries(
    Object.entries(persisted).filter(([, value]) => Boolean(value))
  ) as Record<string, string>
}
